import { Backdrop, Dialog, Paper } from "@mui/material";
import CustomAlert from "../alert/alert";

const CustomDialog = ({
    withAlert,
    onClick,
    alertSeverity,
    alertMessage,
    alertActions,
    ...props
}) => {
    return (
        <Dialog
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: "rgba(8, 8, 27, 0.8)",
                    },
                },
            }}
            PaperComponent={withAlert ? "div" : Paper}
            PaperProps={{
                sx: withAlert && {
                    margin: 0,
                    maxHeight: "none",
                    overflowY: "visible",
                },
            }}
            {...props}
        >
            {withAlert && (
                <div className="mt-4 mx-4 md:mx-0 md:mt-0">
                    <CustomAlert
                        variant="filled"
                        severity={alertSeverity}
                        message={alertMessage}
                        actions={alertActions}
                    />
                </div>
            )}

            {withAlert ? (

                
                <div className="bg-white rounded-t-4xl rounded-b-none md:rounded-4xl h-auto mt-auto md:mt-3">
                    {props.children}
                </div>
            ) : (
                props.children
            )}
        </Dialog>
    );
};

export default CustomDialog;

